import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
const Message = (props) => {
    let { messageId = '', values, className, tagName, escapeHtml } = props;
    const { t } = useTranslation();
    const translate = () => {
        return t(messageId, values);
    };
    const output = () => {
        if (escapeHtml) {
            if (tagName == 'p') {
                return React.createElement("p", { className: className, dangerouslySetInnerHTML: { __html: translate() } });
            }
            else if (tagName == 'div') {
                return React.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: translate() } });
            }
            else {
                return (React.createElement("span", { className: className, dangerouslySetInnerHTML: { __html: translate() } }));
            }
        }
        else {
            if (tagName == 'p') {
                return React.createElement("p", { className: className }, translate());
            }
            else if (tagName == 'div') {
                return React.createElement("div", { className: className }, translate());
            }
            else {
                return React.createElement("span", { className: className }, translate());
            }
        }
    };
    return React.createElement(React.Fragment, null, output());
};
Message.propTypes = {
    messageId: PropTypes.string.isRequired,
    values: PropTypes.object,
    className: PropTypes.string,
    tagName: PropTypes.string,
    escapeHtml: PropTypes.bool,
};
export default Message;
